

function downloadSingleProductItem(e) {
		if(e) {
				e.preventDefault();
		}
		const thisButton = e.target.closest('.button--loader');
		thisButton.setAttribute('disabled','disabled');
		thisButton.classList.add('working');

		let currentVariant = thisButton.getAttribute('data-variants');
		let currentHash = thisButton.getAttribute('data-hash');

		// get active variant:
		const activeSelect = document.querySelector('.product-variant select.product-variant__container--select');
		if(activeSelect !== null) {
			if(typeof variantHashes !== "undefined") {
				if(variantHashes.hasOwnProperty(activeSelect.value)) {
					currentHash = variantHashes[activeSelect.value].hash;
					currentVariant = variantHashes[activeSelect.value].id;
					existingVariant = variantHashes[activeSelect.value].existing;
				}
			}
		}

		if(thisButton.classList.contains('downloadSingleProductItem')) {
			// downloaded from the account page, so will have a sibling variant purchased:
			existingVariant = 'true';
		}

		// single products won't be part of a bundle:
		let bundle_overide = '-';

		let config = {
		method: 'POST',
		headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
		'Accept': 'application/json',
		'X-ABSOLUTE-HMAC': currentHash, 
		'X-ABSOLUTE-SESSION': thisButton.getAttribute('data-session') 
		},
		body: 'variants='+currentVariant+'&customer_id='+thisButton.getAttribute('data-customer')+'&existing_variants='+existingVariant+'&bundle_overide='+bundle_overide
		}

		fetch('https://visune.sawblade.org.uk/api/processBulkDownload/index.php', config)
		.then((response) => response.json())
		.then((response) => {
		if(typeof response.status !== "undefined") {
		
		if(response.status == 'success') {

			if(typeof response.tokens_remaining !== "undefined") {
				window.localStorage.setItem("correctUnitsRemaining", response.tokens_remaining);
			}
			// package up the data so it's easier to parse in liquid
			let i;
			let responseOutput = '';
			for (i in response.success) {
				if(responseOutput != '') {
					responseOutput += "___";
				}
				responseOutput += response.success[i].id+"|||"+response.success[i].title+"|||"+response.success[i].img;
				logDownloadEvent(response.success[i].id, response.success[i].title, response.success[i].token_cost, response.success[i].collection_title, response.success[i].variant_title);
			}
			window.location = '/cart/update?attributes[success]='+responseOutput+'&return_to=/pages/downloads';

		


		} else {
		// error
		if(document.getElementById('downloadSinglePurchaseFailed')) {
			document.getElementById('downloadSinglePurchaseFailed').style.display = 'block';
		}

		thisButton.removeAttribute('disabled');
		thisButton.classList.remove('working');


		}
		}

		});



















}

function downloadAllCartItems(e) {
		if(e) {
				e.preventDefault();
		}

		const thisButton = e.target.closest('.button--loader');
		thisButton.setAttribute('disabled','disabled');
		thisButton.classList.add('working');


let config = {
				method: 'POST',
				headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Accept': 'application/json',
						'X-ABSOLUTE-HMAC': thisButton.getAttribute('data-hash'), 
						'X-ABSOLUTE-SESSION': thisButton.getAttribute('data-session') 
				},
				body: 'variants='+thisButton.getAttribute('data-variants')+'&customer_id='+thisButton.getAttribute('data-customer')+'&existing_variants='+thisButton.getAttribute('data-existing')+'&bundle_overide='+thisButton.getAttribute('data-bundleoveride')


		}

		fetch('https://visune.sawblade.org.uk/api/processBulkDownload/index.php', config)
			.then((response) => response.json())
			.then((response) => {
	
				if(typeof response.status !== "undefined") {




						if(response.status == 'success') {

								
							
								// clear cart:
								fetch(window.Shopify.routes.root + 'cart/clear.js', {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json'
									}
								})
								.then(response => {
									return response.json();
								})
								.finally(() => {
									if(typeof response.tokens_remaining !== "undefined") {
										window.localStorage.setItem("correctUnitsRemaining", response.tokens_remaining);
									}
					
								
									// https://community.shopify.dev/t/get-query-params-in-liquid/1593/5



// package up the data so it's easier to parse in liquid
let i;
let responseOutput = '';
for (i in response.success) {
		if(responseOutput != '') {
				responseOutput += "___";
		}



		responseOutput += response.success[i].id+"|||"+response.success[i].title+"|||"+response.success[i].img;
		logDownloadEvent(response.success[i].id, response.success[i].title, response.success[i].token_cost, response.success[i].collection_title, response.success[i].variant_title);
}



								window.location = '/cart/update?attributes[success]='+responseOutput+'&return_to=/pages/downloads';

								});        
						} else {


							if((response.reason == 'Security check failed - HMAC ') || (response.reason == 'Security check failed - Session')) {
								// set correctUnitsRemaining to trigger the warning message
								//console.log("seetting fallback error message");
								window.localStorage.setItem("correctUnitsRemaining", "session error");
								window.location = '/cart/';
							} else {


							
							let tokensRemaining = '';
							if(typeof response.tokens_remaining !== "undefined") {
						 		tokensRemaining = response.tokens_remaining;
							} 

							// remove those that were successful:
							let updates = {};




							for(successfulVariant in response.success) {


								// remove from DOM:
								if(document.getElementById("item-"+response.success[successfulVariant].id)) {
									document.getElementById("item-"+response.success[successfulVariant].id).remove();
								}
								// remove from cart:
								updates[(response.success[successfulVariant].id)] = 0;
								 }
								


		
						fetch(window.Shopify.routes.root + 'cart/update.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({ updates })
						})
						.then(response => {
							return response.json();
						})
						.finally(() => {
						 // reload page to get remaining items with new hash
						 // use local storage to display a message on reload - and save expected token amount as the metafield may not have updated yet
						 if(tokensRemaining != '') {
						 	window.localStorage.setItem("correctUnitsRemaining", tokensRemaining);
						}
							window.location = '/cart/';
								}); 
							}

						}
				}
		 
			});


}document.addEventListener( "click", catchDownloadButton );
// the button may not exist on page load:
function catchDownloadButton(event){
		if(event.target.closest('.button')){
			if(event.target.closest('.button').id == 'downloadCartItems'){
					downloadAllCartItems(event);
			} else if (event.target.closest('.button').id == 'saveMixedCart') {
						saveMixedCart(event);
				}
	}
}


if(document.getElementById('downloadSingleProductItem')) {
	document.getElementById('downloadSingleProductItem').onclick = downloadSingleProductItem;
}


function initDownloadSiblingButtons() {
	const allDownloadSiblingButtons = document.querySelectorAll('.downloadSingleProductItem');
	if (allDownloadSiblingButtons.length > 0) {
		for (i = 0; i < allDownloadSiblingButtons.length; i++) {
			allDownloadSiblingButtons[i].onclick = downloadSingleProductItem;
		}
	}
}

initDownloadSiblingButtons();


function topupSubscriptionSavedMixedCart(e) {
		if(e) {
				e.preventDefault();
		}

		window.sessionStorage.removeItem("checkout_visit");
		
		// save cart items to localstorage
		let localStorageVariants = [];

			document.querySelectorAll('#AjaxCartForm .cart-variant-item').forEach(cart_item=>{
					localStorageVariants.push(cart_item.getAttribute('data-variant_id'));
			});

		window.localStorage.setItem('savedCart', JSON.stringify(localStorageVariants));// empty cart:
		fetch(window.Shopify.routes.root + 'cart/clear.js', {
				method: 'POST',
				headers: {
						'Content-Type': 'application/json'
				}
		})
		.then(response => {
				return response.json();
		})
		.finally(() => {
				if(storedReferenceToOriginalButton != null) {
					storedReferenceToOriginalButton.closest('.button').click();
				} else {
					// click the button 'underneath'
					e.target.closest('.primaryCTAWrapper').querySelector('.button').click();
				}

		});



}




const allSavedMixedCart = document.querySelectorAll('.savedMixedCart');
if (allSavedMixedCart.length > 0) {
	for (i = 0; i < allSavedMixedCart.length; i++) {
		allSavedMixedCart[i].onclick = topupSubscriptionSavedMixedCart;
	}
}

